// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Logs (admin) — five surfaces, filter/search/export.
 * Tables → cards handled by enterprise.css (.pro-table @ <=576px).
 */
.ent.admin-logs-page { padding: 24px; }
.ent.admin-logs-page .filter-tabs { margin: 16px 0 14px; }
.ent.admin-logs-page .pro-table-wrap { margin-bottom: 16px; }

.ent.admin-logs-page .logs-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 14px;
}
.ent.admin-logs-page .logs-filter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.72rem;
  color: var(--ent-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.ent.admin-logs-page .logs-filter input,
.ent.admin-logs-page .logs-filter select {
  min-width: 160px;
  min-height: 38px;
  padding: 0.5rem 0.625rem;
  border: 1px solid var(--ent-border-strong);
  border-radius: 8px;
  background: var(--ent-card-alt);
  color: var(--ent-text);
  font-size: 0.85rem;
  text-transform: none;
  letter-spacing: normal;
}
.ent.admin-logs-page .logs-filter input:focus,
.ent.admin-logs-page .logs-filter select:focus {
  outline: none;
  border-color: var(--ent-primary);
}

.ent.admin-logs-page .logs-detail {
  display: inline-block;
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  color: var(--ent-text-2);
}

.ent.admin-logs-page .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: var(--ent-muted);
  gap: 0.25rem;
}
.ent.admin-logs-page .empty-state svg { color: var(--ent-muted); margin-bottom: 0.5rem; }
.ent.admin-logs-page .empty-state p { margin: 0; font-weight: 600; color: var(--ent-text); }

@media (max-width: 768px) {
  .ent.admin-logs-page { padding: 16px; }
  .ent.admin-logs-page .logs-filter,
  .ent.admin-logs-page .logs-filter input,
  .ent.admin-logs-page .logs-filter select { min-width: 0; width: 100%; }
  .ent.admin-logs-page .logs-filter { flex: 1 1 140px; }
}
@media (max-width: 576px) {
  /* In card mode the truncated detail should wrap fully. */
  .ent.admin-logs-page .logs-detail { max-width: 100%; white-space: normal; text-align: right; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/AdminLogs.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF,uBAAuB,aAAa,EAAE;AACtC,oCAAoC,mBAAmB,EAAE;AACzD,uCAAuC,mBAAmB,EAAE;;AAE5D;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA,wCAAwC,uBAAuB,EAAE,qBAAqB,EAAE;AACxF,sCAAsC,SAAS,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAE3F;EACE,uBAAuB,aAAa,EAAE;EACtC;;6CAE2C,YAAY,EAAE,WAAW,EAAE;EACtE,oCAAoC,eAAe,EAAE;AACvD;AACA;EACE,yDAAyD;EACzD,oCAAoC,eAAe,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AAC/F","sourcesContent":["/*\n * Logs (admin) — five surfaces, filter/search/export.\n * Tables → cards handled by enterprise.css (.pro-table @ <=576px).\n */\n.ent.admin-logs-page { padding: 24px; }\n.ent.admin-logs-page .filter-tabs { margin: 16px 0 14px; }\n.ent.admin-logs-page .pro-table-wrap { margin-bottom: 16px; }\n\n.ent.admin-logs-page .logs-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n.ent.admin-logs-page .logs-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 0.72rem;\n  color: var(--ent-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.ent.admin-logs-page .logs-filter input,\n.ent.admin-logs-page .logs-filter select {\n  min-width: 160px;\n  min-height: 38px;\n  padding: 0.5rem 0.625rem;\n  border: 1px solid var(--ent-border-strong);\n  border-radius: 8px;\n  background: var(--ent-card-alt);\n  color: var(--ent-text);\n  font-size: 0.85rem;\n  text-transform: none;\n  letter-spacing: normal;\n}\n.ent.admin-logs-page .logs-filter input:focus,\n.ent.admin-logs-page .logs-filter select:focus {\n  outline: none;\n  border-color: var(--ent-primary);\n}\n\n.ent.admin-logs-page .logs-detail {\n  display: inline-block;\n  max-width: 360px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: bottom;\n  color: var(--ent-text-2);\n}\n\n.ent.admin-logs-page .empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  color: var(--ent-muted);\n  gap: 0.25rem;\n}\n.ent.admin-logs-page .empty-state svg { color: var(--ent-muted); margin-bottom: 0.5rem; }\n.ent.admin-logs-page .empty-state p { margin: 0; font-weight: 600; color: var(--ent-text); }\n\n@media (max-width: 768px) {\n  .ent.admin-logs-page { padding: 16px; }\n  .ent.admin-logs-page .logs-filter,\n  .ent.admin-logs-page .logs-filter input,\n  .ent.admin-logs-page .logs-filter select { min-width: 0; width: 100%; }\n  .ent.admin-logs-page .logs-filter { flex: 1 1 140px; }\n}\n@media (max-width: 576px) {\n  /* In card mode the truncated detail should wrap fully. */\n  .ent.admin-logs-page .logs-detail { max-width: 100%; white-space: normal; text-align: right; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
